import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  memberDetailActions,
  selectConnectUserStatusError,
  selectedIsDeletedAccount,
  selectMemberDetail,
  selectMemberDetailLoading,
} from 'features/member/reducer/memberDetailSlice';

import ContentLayout from 'components/common/layouts/ContentLayout';
import InformModal from 'components/common/modal/InformModal';
import CheckAccountDeletionButton from './checkAccountDeletionButton';
import CommentHistoryModalContainer from 'containers/memberdetail/CommentHistoryModalContainer';
import { TabPanel } from 'components/common/tabs';
import {
  getMemberDetailTabList,
  getMemberDetailTabValue,
  MemberDetailTabValue,
} from './MemberDetailTab';
import MemberDetailGeneral from './memberDetailGeneral';
import MemberDetailConnect from './memberDetailConnect';
import TabLayout from 'components/common/layouts/TabLayout';

import { EmailSectionWrapper } from './MemberDetailContainer.styled';
import MemberDetailCloset from './memberDetailCloset';

interface Props {
  userId: string;
}

const MemberDetailContainer = ({ userId }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const generalInformationLoading = useSelector(selectMemberDetailLoading);
  const connectStatusError = useSelector(selectConnectUserStatusError);
  const generalInformation = useSelector(selectMemberDetail);
  const isDeletedAccount = useSelector(selectedIsDeletedAccount);

  const [isMounted, setIsMounted] = useState<boolean>(false);
  const [commentHistoryModalOpen, setCommentHistoryModalOpen] = useState<boolean>(false);

  const { email, status } = generalInformation;

  const [selectedTab, setSelectedTab] = useState<MemberDetailTabValue>(
    MemberDetailTabValue.GENERAL,
  );

  const fetchData = () => {
    dispatch(memberDetailActions.getMemberDetail({ userId, skipLoading: isMounted }));
    dispatch(memberDetailActions.getCommentList({ userId }));
    dispatch(memberDetailActions.getEmailChangeHistory({ userId }));
    if (!isDeletedAccount) {
      dispatch(memberDetailActions.getMemberDeletionStatus({ userId }));
    }
  };

  useEffect(() => {
    fetchData();
    setIsMounted(true);
  }, []);

  useEffect(() => {
    setSelectedTab(getMemberDetailTabValue(history.location.pathname));
  }, [history.location.pathname]);

  const onCloseErrorModal = () => {
    dispatch(memberDetailActions.updateConnectUserStatusSuccess());
  };

  const statusText = (() => {
    switch (status) {
      case 1:
        return '정상';
      case -2:
        return 'Re-signup';
      default:
        return '탈퇴';
    }
  })();

  return (
    <>
      <CommentHistoryModalContainer
        commentHistoryModalOpen={commentHistoryModalOpen}
        closeCommentHistoryModal={() => {
          setCommentHistoryModalOpen(false);
        }}
      />

      {/* error modal*/}
      <InformModal
        open={connectStatusError}
        onClose={onCloseErrorModal}
        description={'Something went wrong.'}
      />

      <ContentLayout pageTitle={'Member Detail'} loading={generalInformationLoading}>
        <EmailSectionWrapper>
          <div>
            <h3>
              {email} (Status: {statusText})
            </h3>
          </div>
          {!isDeletedAccount && <CheckAccountDeletionButton />}
        </EmailSectionWrapper>
        <TabLayout
          tabs={getMemberDetailTabList(userId)}
          selectedTab={selectedTab}
          onChange={() => fetchData()}
        >
          <div>
            <TabPanel value={MemberDetailTabValue.GENERAL} spacing={8}>
              <MemberDetailGeneral userId={userId} />
            </TabPanel>
            <TabPanel value={MemberDetailTabValue.CLOSET} spacing={8}>
              <MemberDetailCloset userId={userId} />
            </TabPanel>
            <TabPanel value={MemberDetailTabValue.CONNECT} spacing={8}>
              <MemberDetailConnect userId={userId} />
            </TabPanel>
          </div>
        </TabLayout>
      </ContentLayout>
    </>
  );
};

export default MemberDetailContainer;
